import { showMessages } from "../../components/AlertMessages/AlertMessages";
import { pRequestPrint, pRequestResultPrint } from "../../service/100/P114Service";

export const onGetRequestPrint = (setLoading, dataReq, setData, toast) => {
    setLoading(true);
    pRequestPrint(dataReq).then(
        (res) => {
            setLoading(false);
            if (res !== undefined) {
                let temp = [];
                let index = 1;
                res.forEach((element) => {
                    temp.push({
                        ...element,
                        index: index,
                    });
                    index++;
                });
                if (temp.length > 0) {
                    setData(temp);
                }
            } else {
                showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
            }
        },
        function (err) {
            if (err.response && err.response.data.status === 401) {
                alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                window.location.href = "/login";
            } else {
                showMessages(toast, "error", `เกิดข้อผิดพลาด : ${err} `, "");
            }
            setLoading(false);
        }
    );
};

export const onGetRequestResultPrint = (setLoading, dataReq, setData, toast) => {
    setLoading(true);
    pRequestResultPrint(dataReq).then(
        (res) => {
            setLoading(false);
            if (res !== undefined) {
                let temp = [];
                let index = 1;
                res.forEach((element) => {
                    temp.push({
                        ...element,
                        index: index,
                    });
                    index++;
                });
                if (temp.length > 0) {
                    setData(temp);
                }
            } else {
                showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
            }
        },
        function (err) {
            if (err.response && err.response.data.status === 401) {
                alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                window.location.href = "/login";
            } else {
                showMessages(toast, "error", `เกิดข้อผิดพลาด : ${err} `, "");
            }
            setLoading(false);
        }
    );
};
